import React from "react";
import * as Animate from "react-reveal";

const idealParticipants = [
  "Professionals with work experience",
  "Managers and aspiring managers",
  "Team leads and high-potential employees",
  "Founders, entrepreneurs and SME operators",
  "Business owners building stronger systems",
  "Organizations developing future leaders",
];

const industries = [
  "Technology",
  "Finance & banking",
  "Operations",
  "Marketing & growth",
  "Product management",
  "Human resources",
  "Consulting",
  "Entrepreneurship",
  "Healthcare",
  "Education & public sector",
];

const MBAValueSection = () => {
  return (
    <section className="py-16 md:py-24 lg:py-28 px-4" id="overview">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-mba-heading gap-10 lg:gap-16 items-end mb-10 lg:mb-12">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center gap-3 font-poppins text-primary text-sm font-extrabold tracking-widest uppercase mb-5">
                <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
                Who this program is for
              </p>
              <h2 className="font-poppins text-primary font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight m-0">
                Built for professionals ready to think beyond their function.
              </h2>
            </div>
          </Animate.Fade>
          <Animate.Fade bottom>
            <p className="font-poppins text-gray text-sm leading-loose m-0">
              You already understand your work. The Global MBA helps you connect
              it to customers, finance, strategy, performance and the wider
              business.
            </p>
          </Animate.Fade>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          <Animate.Fade bottom>
            <article className="border border-hire-line rounded-3xl min-h-[430px] p-8">
              <span className="block font-poppins text-secondary text-xs font-extrabold tracking-[0.14em] uppercase mb-6">
                Ideal participants
              </span>
              {idealParticipants.map((item, i) => (
                <div
                  key={item}
                  className={`grid grid-cols-mba-list-38 gap-3 py-4 ${
                    i < idealParticipants.length - 1
                      ? "border-b border-hire-line"
                      : ""
                  }`}
                >
                  <span className="font-poppins text-secondary font-extrabold text-sm">
                    0{i + 1}
                  </span>
                  <p className="font-poppins text-default text-sm m-0">
                    {item}
                  </p>
                </div>
              ))}
            </article>
          </Animate.Fade>

          <Animate.Fade bottom>
            <article className="bg-hire-tint-yellow rounded-3xl min-h-[430px] p-8">
              <span className="block font-poppins text-secondary text-xs font-extrabold tracking-[0.14em] uppercase mb-6">
                Professional backgrounds
              </span>
              <h3 className="font-poppins text-primary font-semibold tracking-tight text-2xl leading-snug max-w-md mb-7">
                Different industries. Shared leadership ambition.
              </h3>
              <div className="flex flex-wrap gap-2">
                {industries.map((industry) => (
                  <span
                    key={industry}
                    className="bg-white text-[#5a4a1e] border border-[#eedda9] rounded-full px-3.5 py-2.5 font-poppins text-sm font-semibold"
                  >
                    {industry}
                  </span>
                ))}
              </div>
            </article>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default MBAValueSection;
